import {TelematicProviderTypeMetadata} from "../../types";

export const REQUEST_COMPANY_TELEMATIC_ACCOUNTS_START = 'REQUEST_COMPANY_TELEMATIC_ACCOUNTS_START';
export const REQUEST_COMPANY_TELEMATIC_ACCOUNTS_COMPLETED = 'REQUEST_COMPANY_TELEMATIC_ACCOUNTS_COMPLETED';
export const REQUEST_COMPANY_TELEMATIC_ACCOUNTS_ERROR = 'REQUEST_COMPANY_TELEMATIC_ACCOUNTS_ERROR';

export const getCompanyTelematicAccounts = () => {
    return {
        type: REQUEST_COMPANY_TELEMATIC_ACCOUNTS_START,
        payload: {}
    };
};

export const getCompanyTelematicAccountsCompleted = (accounts: TelematicProviderTypeMetadata[]) => {
    return {
        type: REQUEST_COMPANY_TELEMATIC_ACCOUNTS_COMPLETED,
        payload: { accounts }
    };
};

export const getCompanyTelematicAccountsError = (error: any) => {
    return {
        type: REQUEST_COMPANY_TELEMATIC_ACCOUNTS_ERROR,
        error: error,
        payload: {}
    };
};
